module.exports = __webpack_public_path__ + "static/media/floating.a088370f.mp4";